import { setPersonSharingAccepted } from '@fs/zion-tree-groups'
import { createGroup, setGroupImage } from '../../../../services/groupservices'

const handleCreateGroup = ({
  formValues: { groupName, groupDescription, groupRules, allowOrdinancesSharingCheck },
  setLoading,
  userCisId,
  uploadedImage,
  showStatusOverlay,
  t,
  onCreateGroup,
  closeOverlay,
}) => {
  setLoading(true)
  const isOrdinanceSharing = allowOrdinancesSharingCheck
  createGroup({
    name: groupName,
    description: groupDescription,
    codeOfConduct: groupRules,
    ordinanceSharing: isOrdinanceSharing,
  })
    .then((res) => {
      const newGroupId = res.headers.id
      const newTreeId = res.headers.treeid
      const promises = [setPersonSharingAccepted(newGroupId, userCisId, true)]

      if (uploadedImage) {
        promises.push(
          setGroupImage(newGroupId, uploadedImage).catch((error) => {
            console.error(error)

            showStatusOverlay({
              message: t(
                'group-management-app.set-group-image.error',
                'An error occurred while uploading a group image.'
              ),
              type: 'error',
              dismissable: true,
            })
          })
        )
      }
      Promise.all(promises).then(async () => {
        // If onCreateGroup returns true, then don't closeOverlay.
        const isDoNotCloseOverlay = await onCreateGroup?.({
          id: newGroupId,
          groupName,
          groupDescription,
          groupRules,
          isOrdinanceSharing,
          treeId: newTreeId,
        })
        if (isDoNotCloseOverlay) return
        closeOverlay()
      })
    })
    .catch((error) => {
      setLoading(false)
      console.error(error)

      const warningHeader = error?.response?.headers?.warning

      if (warningHeader?.includes('40020')) {
        // User already at group limit
        showStatusOverlay({
          message: t('create-edit-group.error.user-at-group-limit'),
          type: 'error',
          dismissable: true,
        })
      } else if (warningHeader?.includes('40315')) {
        // User under 18
        showStatusOverlay({
          message: t('create-edit-group.under-18-create.error'),
          type: 'error',
          dismissable: true,
        })
      } else {
        // unexpected error
        showStatusOverlay({
          message: t('create-edit-group.error.unexpected-error-create'),
          type: 'error',
          dismissable: true,
        })
      }
    })
}

export default handleCreateGroup
